import Swiper, {Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination} from 'swiper';
import GLightbox from "glightbox";
import Selectra from 'selectra';


document.addEventListener("DOMContentLoaded", function (event) {

    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');

    if (menu_button) {
        menu_button.addEventListener('click', () => {
            document.body.classList.toggle('body--show');
        })
    }

    const user_button = document.querySelector('[data-behaviour="toggle-user"]');
    if (user_button) {
        const setUserMenu = (open) => {
            document.body.classList.toggle('user--show', open);
            user_button.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        user_button.addEventListener('click', () => {
            setUserMenu(!document.body.classList.contains('user--show'));
        });
        // Close the profile menu on outside click and on Escape
        document.addEventListener('click', (event) => {
            if (!event.target.closest('.user_menu')) {
                setUserMenu(false);
            }
        });
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                setUserMenu(false);
            }
        });
    }

    const cart_button = document.querySelector('[data-behaviour="toggle-cart"]');
    if (cart_button) {
        cart_button.addEventListener('click', (event) => {
            if (window.innerWidth > 768) {
                //Only use hovering cart when on desktop
                event.preventDefault();
                document.body.classList.toggle('cart--show');
            }
        })
    }

    let order_form_buttons = document.querySelectorAll('[data-behaviour="toggle-order_form"]');
    if (order_form_buttons) {
        order_form_buttons.forEach(function (order_form_button) {
            order_form_button.addEventListener('click', (event) => {
                document.body.classList.toggle('order_form--show');
            })
        });
    }

    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    const sliders = document.querySelectorAll('.swiper');

    // init Swiper:
    sliders.forEach(function (slider) {
        const autoSwiper = slider.classList.contains('swiper--auto');
        const swiper = new Swiper(slider, {
            // configure Swiper to use modules
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            direction: 'horizontal',
            loop: true,

            autoplay: autoSwiper ? {
                delay: 7000,
            } : false,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });

    });

    const header = document.querySelector('.header');

    if (header) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 30) {
                header.classList.add('header--sticky');
            } else {
                header.classList.remove('header--sticky');
            }
        });
    }

    if (document.querySelector('[data-js="contact-select"]')) {
        const customSelect = new Selectra('[data-js="contact-select"]', {
            search: true,
            langInputPlaceholder: 'Suchen...',
        })
        customSelect.init()

        const contactSelectContainer = document.querySelector('#ContactID_Holder');
        contactSelectContainer.classList.add('field--hidden');

        const shippingAddressSelectionContainer = document.querySelector('#ShippingAddressSelection_Holder');
        shippingAddressSelectionContainer.classList.add('field--hidden');

        const updateFields = (purpose) => {
            console.log(purpose);
            if (purpose === 1 || purpose === 2) {
                contactSelectContainer.classList.remove('field--hidden');
                shippingAddressSelectionContainer.classList.remove('field--hidden');
            } else {
                contactSelectContainer.classList.add('field--hidden');
                shippingAddressSelectionContainer.classList.add('field--hidden');
            }
        }

        const purposeInputs = document.querySelectorAll('[name="Purpose"]');
        if (purposeInputs.length) {
            purposeInputs.forEach(function (field) {
                field.addEventListener('change', (event) => {
                    updateFields(parseInt(field.value));
                });
            })
        }

    }


    // const sendAndReload = function (field, value) {
    //   const data = new FormData();
    //   data.append(field, value);
    //   const costCenter = document.querySelector('[name="App-Shop-PurposeCheckoutComponent_CostCenter"]');
    //   if (costCenter) {
    //       data.append('CostCenter', costCenter.value);
    //   }
    //   fetch('checkout/updatedata', {
    //     method: 'POST',
    //     body: data
    //   }).then(function (response) {
    //     return response.text();
    //   }).then(function (html) {
    //     document.querySelector('[data-js="checkout-form"]').innerHTML = html;
    //     initCheckout();
    //   });
    // }
    //
    //
    // const initCheckout = () => {
    //   if (document.querySelector('[data-js="contact-select"]')) {
    //     const customSelect = new Selectra('[data-js="contact-select"]', {
    //       search: true,
    //       langInputPlaceholder: 'Suchen...',
    //     })
    //     customSelect.init()
    //   }
    //
    //   const purposeInputs = document.querySelectorAll('[name="App-Shop-PurposeCheckoutComponent_Purpose"]');
    //   if (purposeInputs.length) {
    //     purposeInputs.forEach(function (field) {
    //       field.addEventListener('change', (event) => {
    //         sendAndReload('Purpose', field.value);
    //       });
    //     })
    //   }
    //
    //   const contactField = document.querySelector('[name="App-Shop-PurposeCheckoutComponent_ContactID"]');
    //   if (contactField) {
    //     contactField.addEventListener('change', (event) => {
    //       sendAndReload('ContactID', contactField.value);
    //     });
    //   }
    //
    // }
    //
    // initCheckout();
});
